import { Suspense } from 'react'
import { useSetReviewerInfo } from '~/entities/user'
import { useResetPaginationOnMount, useSyncDateReceivedFilterType } from '../model'
import { ActionsBar, ActionsBarLoadingSkeleton } from './actions-bar'
import { DocumentsTable } from './documents-table/documents-table'
import { LoadingSkeleton as DocumentsTableLoadingSkeleton } from './documents-table/loading-skeleton'
import { Filters } from './filters'
import { PaginationBar } from './pagination-bar'

export function DocumentsPage() {
  useResetPaginationOnMount()
  useSyncDateReceivedFilterType()
  const { isLoading } = useSetReviewerInfo()

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <Suspense fallback={<ActionsBarLoadingSkeleton />}>
        <ActionsBar />
      </Suspense>
      <div className="flex-1 overflow-hidden">
        {isLoading ? (
          <DocumentsTableLoadingSkeleton />
        ) : (
          <Suspense fallback={<DocumentsTableLoadingSkeleton />}>
            <DocumentsTable />
          </Suspense>
        )}
      </div>
      <PaginationBar />
      <Filters />
    </div>
  )
}
